__turbopack_context__.v({
  "btnLink": "krenbG_btnLink",
  "cancelEditButton": "krenbG_cancelEditButton",
  "editFinishButton": "krenbG_editFinishButton",
});
